define(
    'services/session',[
        "plugins/router",
        "services/log",
        "providers/dataprovider",
        "services/storage"
    ],
    function (router, log, dataProvider, store) {
        var _settings = ko.observable({});
        var _settingsGuided = ko.observable({});

        var vm = {};

        vm.suspendBusy = false;
        vm.user = ko.observable();
        vm.role = -1;
        vm.isAuthenticated = ko.computed(function () {
            return vm.user() && !!vm.user().isAuthenticated;
        });
        vm.isCustomerTrial = -1;
        vm.checkSubscription = true;
        vm.validateResult = null;

        vm.login = function (username, password, rememberMe) {
            var d = $.Deferred();

            dataProvider.accounts
            .login({ username: username, password: password, rememberMe: rememberMe })
            .done(function (data) {
                d.resolve(true);
            })
            .fail(function (e) {
                d.reject(e);
            });

            return d.promise();
        };
        vm.logout = function () {
            var p = $.Deferred();

            dataProvider.accounts
            .logout()
            .always(function () {
                resetUser();

                p.resolve();

                // hard-reset 
                //window.location.assign("#login");
                //window.location.reload(true);
            }).
            fail(function (result) {
                //todo: ensure developers are notified that couldn't log out on server.
                log.error("logout: server error %o", result); // check the chrome dev. tool network tab for the actual exception.
            });

            return p.promise();
        };
        vm.settings = function (kvps) {
            if (arguments.length == 1) {
                var observableKVPs = ko.mapping.fromJS(kvps);

                // provide auto-persist for setting value change.
                for (key in kvps) {
                    (function (key) {
                        observableKVPs[key].subscribe(function (newValue) {
                            vm.suspendBusy = true;
                            dataProvider.settings
                            .updateSetting(key, newValue.toString())
                            .always(function () {
                                vm.suspendBusy = false;
                            });
                        });
                    })(key);
                }

                var existing = _settings();

                _.extend(existing, observableKVPs);

                _settings(existing);

                store.setObject('explorer-window-settings', kvps);
            }

            return _settings();
        };
        vm.settingsGuided = function (kvps) {
            if (arguments.length == 1) {

                var observableKVPs = ko.mapping.fromJS(kvps);

                // provide auto-persist for setting value change.
                for (key in kvps) {
                    (function (key) {
                        observableKVPs[key].subscribe(function (newValue) {
                            vm.suspendBusy = true;
                            dataProvider.settings
                            .updateSettingGuided(ko.mapping.toJS(_settingsGuided()))
                            .always(function () {
                                vm.suspendBusy = false;
                            });
                        });
                    })(key);
                }

                var existing = _settingsGuided();

                _.extend(existing, observableKVPs);

                _settingsGuided(existing);
            }

            return _settingsGuided();
        };
        vm.validateLogin = function () {
            var d = $.Deferred();

            d.resolve(vm.validateResult != null);

            //dataProvider.accounts
            //.validate()
            //.done(function (data) {

            //    sessionStorage.removeItem("status:instancecode");
            //    sessionStorage.removeItem("__istest");

            //    //if (window.fileplan && window.fileplan.instanceCode && window.fileplan.instanceCode == "radfp01"){
            //    //    if (data.emailAddress == "consultant@radix.com.au") {
            //    //        sessionStorage.setItem("__istest", "1");
            //    //    }
            //    //}

            //    setUser(data)
            //    .done(function () {
            //        d.resolve(true);
            //    })
            //    .fail(function () {
            //        d.reject(false);
            //    });
            //})
            //.fail(function (e) {                               
            //    d.resolve(false);
            //});

            return d.promise();
        }
        vm.getServerStatus = function () {
            var d = $.Deferred();

            //sessionStorage.setItem("status:server", "");
            var s = sessionStorage.getItem("status:server");

            d.resolve(s);

            return d.promise();
        };
        vm.getSubscriptionStatus = function () {
            var d = $.Deferred();

            //sessionStorage.setItem("status:subscription", "10");
            var s = sessionStorage.getItem("status:subscription");

            d.resolve(s);

            return d.promise();
        };
        vm.getInstanceCodeStatus = function () {
            var d = $.Deferred();
            var s = "";

            vm.validateResult = null;

            dataProvider.accounts
            .validate()
            .done(function (data) {

                vm.validateResult = data;

                sessionStorage.removeItem("status:instancecode");
                sessionStorage.removeItem("__istest");

                //if (window.fileplan && window.fileplan.instanceCode && window.fileplan.instanceCode == "radfp01"){
                //    if (data.emailAddress == "consultant@radix.com.au") {
                //        sessionStorage.setItem("__istest", "1");
                //    }
                //}

                setUser(data)
                .done(function () { })
                .fail(function () { })
                .always(function () {
                    sessionStorage.setItem("status:instancecode", s);

                    d.resolve(s);
                });

            })
            .fail(function (e) {
                if (_.isArray(e.error)) {
                    if (e.error[0].phrase.indexOf("1001:") != -1) {
                        s = e.error[0].phrase;
                    }
                }

                sessionStorage.setItem("status:instancecode", s);

                d.resolve(s);
            });

            return d.promise();
        };

        //FPA-1375 - for hiding warning message when user is readonly publish on the selected document
        // need further implementation for list
        vm.getRoleLibrary = function (id) {
            var d = $.Deferred();

            dataProvider
            .accesscontrollibrary
            .getAccessControl(id)
            .done(function (data) {
                var person = _.find(data.accessControlPersons, function (itm) {
                    return itm.personId == vm.user().userId();
                });

                d.resolve(person ? person.roleId : -1);
            })
            .fail(function (e) {
                d.reject(-1);
            });

            return d.promise();
        };

        vm.getIsSuspended = function () {
            var d = $.Deferred();

            dataProvider.subscription
            .getCustomerSubs()
            .done(function (subs) {
                d.resolve(subs.instanceStatusID == 7);
            })
            .fail(function (e) {
                e.stopPropagation = true;

                console.error(e);

                d.reject(e);
            });

            return d.promise();
        };

        return vm;

        function setUser(user) {
            var d = $.Deferred();

            user.isAuthenticated = true;
            vm.user(ko.mapping.fromJS(user));

            $.when(fetchRole(), fetchSettings(), fetchSettingsGuided())
            .done(function () {
                $.when(setCulture(), setSubscription())
                .always(function () {
                    d.resolve();
                });
            })
            .fail(function () {
                d.reject();
            })

            return d.promise();

            function setSubscription() {
                var d = $.Deferred();

                if (!vm.checkSubscription) {
                    d.resolve();

                    return;
                }

                vm.isCustomerTrial = -1;

                //instance admin
                if (vm.role == 4) {
                    dataProvider.subscription
                    .isCustomerTrial({ instanceId: window.fileplan.instanceCode })
                    .done(function (subs) {
                        vm.isCustomerTrial = subs.isTrial ? 1 : 0;
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;

                        console.error(e);
                    })
                    .always(function () {
                        vm.checkSubscription = false;

                        d.resolve();
                    });
                } else {
                    d.resolve();
                }

                return d.promise();
            }
            function setCulture() {
                var d = $.Deferred();
                var culture = !vm.user().cultureCode() ? 'en-US' : vm.user().cultureCode();

                if (!store.get('culture') || (store.get('culture') != culture)) store.set('culture', culture);

                window.fileplan.settings.locale = culture;

                //var host = window.location.origin;
                //host = host.replace("https:", "");
                //host = host.replace("http:", "");

                //$.get(host + '/libraries/kendo/cultures/kendo.culture.' + window.fileplan.settings.locale + '.min.js?' + window.fileplan.version, function (data) {
                //    kendo.culture(window.fileplan.settings.locale);

                //    d.resolve();
                //});

                //require([host + '/libraries/kendo/cultures/kendo.culture.' + window.fileplan.settings.locale + '.min'], function (kc) {
                //    kendo.culture(window.fileplan.settings.locale);

                //    d.resolve();
                //});

                require(['kendocultures/kendo.culture.' + window.fileplan.settings.locale + '.min'], function (kc) {
                    kendo.culture(window.fileplan.settings.locale);

                    d.resolve();
                });

                return d.promise();
            }
        }
        function resetUser() {
            vm.isCustomerTrial = -1;
            vm.checkSubscription = true;
            vm.role = -1;
            vm.user({
                userId: null,
                firstName: null,
                lastName: null,
                displayName: null,
                emailAddress: null,
                isAuthenticated: false,
                cultureCode: null
            });
        }

        function fetchRole() {
            return dataProvider.accounts
                .getRole()
                .done(function (data) {
                    vm.role = data;
                })
                .fail(function () {
                    vm.role = -1;
                });
        };
        function fetchSettings() {
            var d = $.Deferred();

            var settings = store.getObject('explorer-window-settings');

            if (!settings) {
                dataProvider.settings
                .getCategorySettings("initial")
                .done(function (data) {
                    vm.settings(data);
                })
                .always(function () {
                    d.resolve();
                });
            } else {
                vm.settings(settings);

                d.resolve();
            }

            return d.promise();
        };
        function fetchSettingsGuided() {
            var d = $.Deferred();

            dataProvider.settings
            .getSetting("setupguide")
            .done(function (data) {
                ////console.warn(data);
                //data = '{"GettingStartedHaveWatchVideo": false, "GettingStartedReadIntro": false, "GettingStartedReadDownloadWindowsClient": false';
                //data = data + ',"LibrariesWatchVideo": false,"LibrariesReadCreateArticle": false,"LibrariesAvailableBluePrints": false,"LibrariesTryCreateTemplateFoldersOnly": false,"LibrariesTryCreateTemplateListFolders": false,"LibrariesReadDeleteArticle": false,"LibrariesUseCreateButton": false';
                //data = data + ',"ImportDocumentsWatchImporterOverviewVideo": false,"ImportDocumentsReadHowToImportSelectedFolder": false,"ImportDocumentsReadAddListValuesBasedOnWindowsFolders": false,"ImportDocumentsReadImportDocumentsRelatedToListValues": false,"ImportDocumentsUseDocumentImporter": false';
                //data = data + ',"AddPeopleReadAddingUsers": false,"AddPeopleUsePeoplePageAddUser": false';
                //data = data + ',"AccessControlWatchVideo": false,"AccessControlCreateTeams": false,"AccessControlSetLibrary": false';
                //data = data + ',"FinishReadConfiguringColumns": false,"FinishReadConfiguringFields": false,"FinishReadSetupTemplateDocuments": false,"FinishReadExportingDocumentsFromFileplan": false';
                //data = data + ',"IsDontShowMeAgainNextLogin": false';
                //data = data + '}';

                vm.settingsGuided(JSON.parse(data));
            })
            .always(function () {
                d.resolve();
            });

            return d.promise();
        };
    });
